import React from "react";
import { ShieldCheck } from "lucide-react";

export function FactToVerifyItem({ fact }) {
	return (
		<li className="monitoring__analysis-strategy-fact-item">
			<span className="monitoring__analysis-strategy-fact-marker" aria-hidden />
			<div className="monitoring__analysis-strategy-fact-content">
				<p className="monitoring__analysis-strategy-fact-text mb-0">{fact.description}</p>
				{fact.required ? (
					<span className="monitoring__analysis-strategy-fact-required">Required</span>
				) : null}
			</div>
		</li>
	);
}

export default function FactsToVerifyList({
	facts,
	heading = "Facts to verify before publishing",
	showLead = false,
	className = "",
}) {
	if (!facts?.length) return null;

	return (
		<div className={className}>
			<h3 className="monitoring__analysis-strategy-brief-heading monitoring__writing-facts-heading">
				<ShieldCheck size={14} aria-hidden />
				{heading}
				<span className="monitoring__analysis-strategy-brief-count">{facts.length}</span>
			</h3>
			{showLead ? (
				<p className="monitoring__writing-facts-lead">
					Confirm these claims against your product documentation before publishing.
				</p>
			) : null}
			<ul className="monitoring__analysis-strategy-fact-list mb-0">
				{facts.map((fact, index) => (
					<FactToVerifyItem key={index} fact={fact} />
				))}
			</ul>
		</div>
	);
}
